import React, { useEffect, useRef, useState } from 'react';
import InputTitleView from './InputTitleView';
import icArrowDown from 'Assets/img/recruitment/ic_arrow_down.png';
import icArrowDown2 from 'Assets/img/recruitment/ic_arrow_down@2x.png';
import icArrowDown3 from 'Assets/img/recruitment/ic_arrow_down@3x.png';
import { getImageSet } from 'Util/DataUtils';

const arrows = getImageSet([icArrowDown, icArrowDown2, icArrowDown3]);
const SelectInputView = ({ title = '', required = false, subTitle = '', placeholder, items = null, name, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const itemWrapRef = useRef();
  const isClickItemWrap = e => {
    if (document.activeElement !== itemWrapRef.current && !itemWrapRef.current?.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', isClickItemWrap);
    return () => {
      document.removeEventListener('click', isClickItemWrap);
    };
  }, []);

  if (!title || !items) return <></>;
  return (
    <div className="recruitment-select-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className={`recruitment-select-input-view-input-wrapper ${open && 'open'}`} ref={itemWrapRef}>
        <div className="recruitment-select-input-view-input" onClick={() => setOpen(x => !x)}>
          {value ? <div className="value">{items[value]}</div> : <div className="placeholder">{placeholder}</div>}
          <img {...arrows} alt="arrow" style={{ ...(open && { transform: 'rotate(180deg)' }) }} />
        </div>
        {open && (
          <div className="recruitment-select-input-view-item-wrapper">
            {Object.entries(items).map(x => (
              <div
                key={x[0]}
                className="recruitment-select-input-view-item"
                onClick={() => {
                  onChange({ name, value: x[0] });
                  setOpen(false);
                }}
              >
                {x[1]}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectInputView;
